import HTTPService from '../../HTTPService'

class Webhook {
  getAll (companySlug, channelSlug) {
    return HTTPService.get(`company/${companySlug}/channel/${channelSlug}/third-party/webhook`)
  }

  add (companySlug, channelSlug, payload) {
    return HTTPService.post(`company/${companySlug}/channel/${channelSlug}/third-party/webhook`, {
      name: payload.name,
      url: payload.url,
      settings: {
        'triggers.new_message': payload.settings['triggers.new_message'],
        'triggers.new_session': payload.settings['triggers.new_session'],
        'triggers.callback_request': payload.settings['triggers.callback_request'],
        'triggers.manual_dialog_switch': payload.settings['triggers.manual_dialog_switch']
      }
    })
  }

  getOne (companySlug, channelSlug, webhookSlug) {
    return HTTPService.get(`company/${companySlug}/channel/${channelSlug}/third-party/webhook/${webhookSlug}`)
  }

  update (companySlug, channelSlug, webhookSlug, payload) {
    return HTTPService.put(`company/${companySlug}/channel/${channelSlug}/third-party/webhook/${webhookSlug}`, {
      name: payload.name,
      url: payload.url,
      settings: {
        'triggers.new_message': payload.settings['triggers.new_message'],
        'triggers.new_session': payload.settings['triggers.new_session'],
        'triggers.callback_request': payload.settings['triggers.callback_request'],
        'triggers.manual_dialog_switch': payload.settings['triggers.manual_dialog_switch']
      }
    })
  }

  delete (companySlug, channelSlug, webhookSlug) {
    return HTTPService.delete(`company/${companySlug}/channel/${channelSlug}/third-party/webhook/${webhookSlug}`)
  }
}

export default new Webhook()
